import 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { HttpClientModule } from '@angular/common/http'; import { HttpModule } from '@angular/http';
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ConfigProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConfigProvider {
  private _database = "";
  private _serverAddress = "";


  get database(): string {
    return this._database;
  }

  get serverAddress(): string {
    return this._serverAddress;
  }

  constructor(public http: Http) {
    console.log('Hello ConfigProvider Provider');
  }

  load() : Promise<any> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      this.http.get('assets/config.json').map(res => res.json()).subscribe(res => {
          this._database = res.database;
          this._serverAddress =  res.serverAddress;
          resolve(true);
        },
        (err) => {
          resolve(false);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/config/config.ts